import { breakpoints } from "./constants/breakpoints";

const styles = {
  "@global": {
    "html, body": {
      [`@media only screen and (min-width: ${breakpoints.lg}px)`]: {
        overscrollBehaviorY: "none",
      },
      [`@media only screen and (max-width: ${breakpoints.md}px)`]: {
        minHeight: "100vh",
      },
    },
  },
};

export default styles;
